/* Jacamar : « De votre plan à votre cuisine », sept scènes en perspective, en boucle.
   Même noyau et même trait que « Fait pour durer » : s'appuie sur HL (assets/jcm-durer.js), chargé avant. */
(()=>{
  const lancer=()=>{
    if(!window.HL||!document.querySelector('.jcm-parcours'))return;
    const {Cam,fit,proj,mk,poly,seg,open,register}=HL;
    const BLANC='#FFFFFF',BEURRE='#F2E9B1',BEURRE2='#E8DC9C',BEURRE3='#D8C273',CRAIE='#F3F2EE',GRIS='#E4E2DC';
    const T=7000,ease=t=>(t=Math.min(1,Math.max(0,t)))<.5?4*t*t*t:1-Math.pow(-2*t+2,3)/2,clamp=(v,a,b)=>Math.max(a,Math.min(b,v)),lerp=(a,b,u)=>a+(b-a)*u;
    const seg01=(t,a,b)=>ease(clamp((t-a)/(b-a),0,1));
    /* un pavé : dessus, face avant (y max), côté (x max) */
    function pave(g,cols,cl){
      const f=(cols||[BLANC,BLANC,BLANC]).map(c=>mk('path',{class:cl||'sil',style:'fill:'+c},g));
      return{el:f,set(P,x0,x1,y0,y1,z0,z1){
        f[0].setAttribute('d',poly([P(x0,y0,z1),P(x1,y0,z1),P(x1,y1,z1),P(x0,y1,z1)]));
        f[1].setAttribute('d',poly([P(x0,y1,z0),P(x1,y1,z0),P(x1,y1,z1),P(x0,y1,z1)]));
        f[2].setAttribute('d',poly([P(x1,y0,z0),P(x1,y1,z0),P(x1,y1,z1),P(x1,y0,z1)]));
        return this}}
    }
    const chemin=(g,cl,st)=>mk('path',st?{class:cl,style:st}:{class:cl},g);
    const cercle=(P,cx,cy,z,r,n=28)=>{const q=[];for(let i=0;i<n;i++){const a=i/n*6.2832;q.push(P(cx+r*Math.cos(a),cy+r*Math.sin(a),z))}return q};
    const fil=(P,x0,x1,y0,y1,z,n=5)=>{let d='';for(let i=1;i<n;i++){const y=y0+(y1-y0)*i/n,q=[];for(let x=x0+1;x<=x1-1;x+=3)q.push(P(x,y+.35*Math.sin(.4*x+i*1.7),z));d+=open(q)}return d};
    const scene=(svg,pts,S,cx=200,cy=200,az=45)=>{const c=Cam(az,.5,S);fit(c,pts,cx,cy);return proj(c)};

    const S={};

    /* 1. Le lien IKEA Planner est copié, collé dans un e-mail, envoyé */
    const texte=(g,P,y,x,z,txt,taille,cl)=>{const o=P(0,y,0),ex=P(1,y,0),ez=P(0,y,1),m=[ex[0]-o[0],ex[1]-o[1],-(ez[0]-o[0]),-(ez[1]-o[1]),o[0],o[1]].map(v=>v.toFixed(3)).join(' ');
      const el=mk('text',{transform:`matrix(${m})`,x:x,y:-z,'font-size':taille,class:cl||'jp-t'},g);el.textContent=txt;return el};
    S.plan=svg=>{
      const P=scene(svg,[[0,-1,0],[52,16,0],[0,-1,36],[52,16,36]],6.2,195,205,22),g=mk('g',{},svg);
      /* la fenêtre du navigateur, au fond */
      pave(g).set(P,0,36,-1.2,0,6,34);
      chemin(g,'sil',`fill:${CRAIE}`).setAttribute('d',poly([P(0,.02,30.5),P(36,.02,30.5),P(36,.02,34),P(0,.02,34)]));
      const url=chemin(g,'sil',`fill:${BLANC}`);url.setAttribute('d',poly([P(3,.04,26),P(33,.04,26),P(33,.04,29),P(3,.04,29)]));
      texte(g,P,.06,4,26.7,(window.jcmT&&jcmT.parcours_planner_url||'planner.ikea.com/fr/…'),2.1);
      [[4,13],[13,22],[22,31]].forEach(([a,b])=>{chemin(g,'sil',`fill:${BEURRE}`).setAttribute('d',poly([P(a,.04,9),P(b,.04,9),P(b,.04,15),P(a,.04,15)]));chemin(g,'sil',`fill:${BEURRE}`).setAttribute('d',poly([P(a,.04,18),P(b,.04,18),P(b,.04,23),P(a,.04,23)]))});
      const copie=mk('g',{},g);chemin(copie,'sil',`fill:${BEURRE}`).setAttribute('d',poly([P(22,.08,30.6),P(33,.08,30.6),P(33,.08,33.4),P(22,.08,33.4)]));texte(copie,P,.1,23,31.2,(window.jcmT&&jcmT.parcours_link_copied||'Lien copié'),1.9);
      /* l'e-mail, devant */
      const mail=mk('g',{},g);pave(mail).set(P,14,50,14,15,0,24);
      chemin(mail,'sil',`fill:${CRAIE}`).setAttribute('d',poly([P(14,15.02,20.5),P(50,15.02,20.5),P(50,15.02,24),P(14,15.02,24)]));
      texte(mail,P,15.05,16,21.4,(window.jcmT&&jcmT.parcours_new_message||'Nouveau message'),2);
      texte(mail,P,15.05,16,17,(window.jcmT&&jcmT.parcours_mail_to||'À : contact@jacamar.fr'),2);
      chemin(mail,'nf lo').setAttribute('d',seg(P(16,15.05,16),P(48,15.05,16))+seg(P(16,15.05,12),P(48,15.05,12)));
      texte(mail,P,15.05,16,12.9,(window.jcmT&&jcmT.parcours_mail_subject||'Objet : mon projet de cuisine'),2);
      const lien=texte(mail,P,15.05,16,8.4,(window.jcmT&&jcmT.parcours_planner_url||'planner.ikea.com/fr/…'),2,'jp-t jp-lien');
      const btn=chemin(mail,'sil',`fill:${BLANC}`);btn.setAttribute('d',poly([P(38,15.05,1.6),P(48,15.05,1.6),P(48,15.05,4.8),P(38,15.05,4.8)]));
      const bt=texte(mail,P,15.08,39.6,2.4,(window.jcmT&&jcmT.parcours_send||'Envoyer'),2);
      const trace=chemin(g,'nf lead','stroke-dasharray:3 4'),env=mk('g',{},g),e1=chemin(env,'sil',`fill:${BLANC}`),e2=chemin(env,'nf sil');
      const pos=u=>[lerp(43,66,u),lerp(15,4,u),lerp(4,40,u)+5*Math.sin(u*3.14)];
      return t=>{
        const sel=t>500&&t<2000;url.style.fill=sel?BEURRE:BLANC;
        copie.style.opacity=(t>1000&&t<2200)?1:0;
        mail.style.opacity=t<1700?0:(t>4600?Math.max(0,1-(t-4600)/500).toFixed(2):1);
        lien.style.opacity=t>2500?1:0;
        const presse=t>3300&&t<3800;btn.style.fill=presse?'#151311':BLANC;bt.style.fill=presse?BLANC:'#151311';
        const u=seg01(t,3700,5600);env.style.opacity=(t>3700&&t<6000)?(t>5600?Math.max(0,1-(t-5600)/400).toFixed(2):1):0;trace.style.opacity=env.style.opacity;
        const [x,y,z]=pos(u);
        e1.setAttribute('d',poly([P(x-3,y,z-2),P(x+3,y,z-2),P(x+3,y,z+2),P(x-3,y,z+2)]));
        e2.setAttribute('d',open([P(x-3,y,z+2),P(x,y,z-.4),P(x+3,y,z+2)]));
        const q=[];for(let k=0;k<=20;k++)q.push(P(...pos(u*k/20)));
        trace.setAttribute('d',u>.02?open(q):'');
      }
    };

    /* 2. La relecture : la loupe passe, un panneau en trop est rayé */
    S.relu=svg=>{
      const P=scene(svg,[[0,0,0],[64,48,0],[0,0,10],[64,48,10]],4.6),g=mk('g',{},svg);
      pave(g).set(P,0,64,0,48,0,.4);
      const z=.42,pans=[];
      for(let r=0;r<2;r++)for(let c=0;c<4;c++){const x0=4+c*14.5,y0=r?26:5,y1=r?43:22;pans.push([x0,x0+13,y0,y1])}
      pans.forEach(([a,b,c,d],i)=>{if(i===7)return;chemin(g,'sil',`fill:${BEURRE}`).setAttribute('d',poly([P(a,c,z),P(b,c,z),P(b,d,z),P(a,d,z)]));chemin(g,'nf grain').setAttribute('d',(()=>{let s='';for(let k=1;k<4;k++){const x=a+(b-a)*k/4;s+=seg(P(x,c+1.5,z),P(x,d-1.5,z))}return s})())});
      const [a,b,c,d]=pans[7];
      const trop=chemin(g,'sil',`fill:${BEURRE}`);trop.setAttribute('d',poly([P(a,c,z),P(b,c,z),P(b,d,z),P(a,d,z)]));
      const pointille=chemin(g,'nf sil','stroke-dasharray:3 3');pointille.setAttribute('d',poly([P(a,c,z),P(b,c,z),P(b,d,z),P(a,d,z)]));
      const r1=chemin(g,'nf hi','stroke-width:2'),r2=chemin(g,'nf hi','stroke-width:2');
      const lp=mk('g',{},g),verre=chemin(lp,'sil','fill:rgba(255,255,255,.55);stroke-width:2.2'),manche=chemin(lp,'nf hi','stroke-width:5;stroke-linecap:round');
      const trajet=[[10,14],[24,14],[38,14],[52,14],[52,34],[38,34],[24,34],[50,35]];
      return t=>{
        const u=clamp(t/3600,0,1)*(trajet.length-1),i=Math.min(trajet.length-2,Math.floor(u)),f=ease(u-i);
        let [lx,ly]=[lerp(trajet[i][0],trajet[i+1][0],f),lerp(trajet[i][1],trajet[i+1][1],f)];
        if(t>5600){const w=seg01(t,5600,6600);lx=lerp(50,10,w);ly=lerp(35,14,w)}
        verre.setAttribute('d',poly(cercle(P,lx,ly,7,7)));
        manche.setAttribute('d',seg(P(lx+5,ly+5,7),P(lx+12,ly+12,6)));
        const s1=seg01(t,3700,4300),s2=seg01(t,4200,4800),fin=t>6400;
        r1.setAttribute('d',s1>0&&!fin?seg(P(a+1,c+1,z),P(a+1+(b-a-2)*s1,c+1+(d-c-2)*s1,z)):'');
        r2.setAttribute('d',s2>0&&!fin?seg(P(b-1,c+1,z),P(b-1-(b-a-2)*s2,c+1+(d-c-2)*s2,z)):'');
        trop.style.opacity=(1-seg01(t,4900,5600)+seg01(t,6500,6900)).toFixed(2);
      }
    };

    /* 3. Les offres s'ouvrent en éventail, l'une est cochée */
    S.offres=svg=>{
      const P=scene(svg,[[4,-2,0],[56,62,0],[4,-2,4],[56,62,4]],4.6,235,200),g=mk('g',{},svg);
      const piv=[28,46],L=26,H=36;
      const feuille=(ang,z)=>{const r=ang*Math.PI/180,co=Math.cos(r),si=Math.sin(r);return[[-L/2,-H],[L/2,-H],[L/2,0],[-L/2,0]].map(([x,y])=>P(piv[0]+x*co-y*si,piv[1]+x*si+y*co,z))};
      const fg=chemin(g,'sil',`fill:${BLANC}`),lg=chemin(g,'nf lo'),fd=chemin(g,'sil',`fill:${BLANC}`),ld=chemin(g,'nf lo');
      const fc=chemin(g,'sil',`fill:${BLANC}`);fc.setAttribute('d',poly(feuille(0,.6)));
      let s='';[[-9,-31,6],[-9,-27,10],[-9,-23,10],[-9,-19,6]].forEach(([x,y,l])=>{s+=seg(P(piv[0]+x,piv[1]+y,.62),P(piv[0]+x+l,piv[1]+y,.62))});
      chemin(g,'nf sil').setAttribute('d',s);
      chemin(g,'nf lo','stroke-dasharray:2 3').setAttribute('d',seg(P(piv[0]-9,piv[1]-8,.62),P(piv[0]+9,piv[1]-8,.62)));
      const ok=chemin(g,'nf hi','stroke-width:2.6');
      [BEURRE,BEURRE2,BEURRE3,'#B59F4E'].forEach((c,i)=>pave(g,[c,c,c]).set(P,6+i*12,16+i*12,52,60,0,2.2));
      const lignes=ang=>{const r=ang*Math.PI/180,co=Math.cos(r),si=Math.sin(r),q=(x,y)=>P(piv[0]+x*co-y*si,piv[1]+x*si+y*co,.32);return seg(q(-9,-30),q(5,-30))+seg(q(-9,-26),q(9,-26))};
      return t=>{
        const o=seg01(t,500,1600)*(1-seg01(t,6000,6800)),ag=-20*o,ad=20*o;
        fg.setAttribute('d',poly(feuille(ag,.3)));lg.setAttribute('d',lignes(ag));
        fd.setAttribute('d',poly(feuille(ad,.3)));ld.setAttribute('d',lignes(ad));
        const k=seg01(t,2400,3200)*(t<6000?1:0),pts=[[-6,-14],[-2,-10],[7,-18]],q=[];
        if(k>0){const n=k*2;q.push(P(piv[0]+pts[0][0],piv[1]+pts[0][1],.64));
          const A=pts[Math.min(1,Math.floor(n))],B=pts[Math.min(2,Math.floor(n)+1)],w=n-Math.floor(n);
          if(n>=1)q.push(P(piv[0]+pts[1][0],piv[1]+pts[1][1],.64));
          q.push(P(piv[0]+lerp(A[0],B[0],n>=2?1:w),piv[1]+lerp(A[1],B[1],n>=2?1:w),.64))}
        ok.setAttribute('d',k>0?open(q):'');
      }
    };

    /* 4. La signature, puis le tampon Bon pour fabrication */
    S.signe=svg=>{
      const P=scene(svg,[[0,0,0],[46,58,0],[0,0,34],[46,58,34]],4.4),g=mk('g',{},svg);
      pave(g).set(P,0,44,0,58,0,.4);
      let s='';[[5,6,22],[5,10,32],[5,14,32],[5,18,20]].forEach(([x,y,l])=>{s+=seg(P(x,y,.42),P(x+l,y,.42))});
      chemin(g,'nf sil').setAttribute('d',s);
      chemin(g,'nf sil').setAttribute('d',seg(P(5,52,.42),P(36,52,.42)));
      const sig=chemin(g,'nf hi','stroke-width:1.8'),empreinte=chemin(g,'nf','stroke:#151311;stroke-width:2'),empreinte2=chemin(g,'nf','stroke:#151311;stroke-width:1');
      const tg=mk('g',{},g),socle=pave(tg,[BEURRE,BEURRE2,BEURRE3]),bouton=pave(tg,[BLANC,BLANC,BLANC]);
      const courbe=[];for(let i=0;i<=60;i++){const x=6+i*.45;courbe.push([x,47-2.2*Math.sin(i*.42)-1.2*Math.sin(i*.17)])}
      return t=>{
        const k=Math.round(seg01(t,400,2400)*60),fade=t>6400?0:1;
        sig.setAttribute('d',k>1&&fade?open(courbe.slice(0,k+1).map(([x,y])=>P(x,y,.44))):'');
        const desc=seg01(t,2800,3300)*(1-seg01(t,4100,4700)),z0=lerp(34,.42,desc);
        tg.style.opacity=(t<2700||t>5200)?0:1;
        socle.set(P,22,34,22,34,z0,z0+3);bouton.set(P,26,30,26,30,z0+3,z0+10);
        const vis=t>3250&&t<6400;
        empreinte.setAttribute('d',vis?poly(cercle(P,28,28,.43,7)):'');
        empreinte2.setAttribute('d',vis?poly(cercle(P,28,28,.43,5)):'');
      }
    };

    /* 5. L'atelier : la façade glisse sous le pistolet et reçoit son vernis */
    S.atelier=svg=>{
      const P=scene(svg,[[-10,0,0],[90,26,0],[0,0,52],[90,26,52]],3.4),g=mk('g',{},svg);
      pave(g).set(P,4,8,4,22,0,26);pave(g).set(P,72,76,4,22,0,26);
      pave(g).set(P,0,80,0,26,26,30);
      const pg=mk('g',{},g),pan=pave(pg,[BEURRE,BEURRE2,BEURRE3]),gr=chemin(pg,'nf grain'),reflet=chemin(pg,'nf','stroke:#FFFFFF;stroke-width:3;stroke-linecap:round');
      const brume=[];for(let i=0;i<14;i++)brume.push({el:mk('circle',{r:1.6,class:'dot m'},g),x:34+((i*37)%12),y:8+((i*53)%10),ph:i/14});
      pave(g,[GRIS,GRIS,GRIS]).set(P,32,46,10,16,46,51);
      pave(g).set(P,36,39,11,15,41,46);
      chemin(g,'nf sil').setAttribute('d',open([P(46,13,48),P(56,13,50),P(62,13,58)]));
      return t=>{
        const xa=lerp(-50,20,seg01(t,0,1400))+lerp(0,80,seg01(t,5200,6600));
        pan.set(P,xa,xa+40,4,22,30,32);gr.setAttribute('d',fil(P,xa,xa+40,4,22,32.05,4));
        const sh=seg01(t,3700,4700);reflet.style.opacity=(sh>0&&sh<1)?1:0;
        reflet.setAttribute('d',seg(P(xa+4+30*sh,6,32.1),P(xa+10+30*sh,20,32.1)));
        const on=t>1700&&t<3900;
        brume.forEach(b=>{const v=((t/900)+b.ph)%1,p=P(b.x+(b.x-40)*v*.6,b.y,40-v*7);b.el.setAttribute('cx',p[0].toFixed(1));b.el.setAttribute('cy',p[1].toFixed(1));b.el.style.opacity=on?(1-v).toFixed(2):0});
      }
    };

    /* 6. Mise en caisse : les façades descendent, le couvercle se pose */
    S.caisse=svg=>{
      const P=scene(svg,[[0,0,0],[52,32,0],[0,0,50],[52,32,50]],4.2),g=mk('g',{},svg);
      chemin(g,'sil',`fill:${GRIS}`).setAttribute('d',poly([P(0,0,0),P(52,0,0),P(52,0,18),P(0,0,18)]));
      chemin(g,'sil',`fill:${GRIS}`).setAttribute('d',poly([P(0,0,0),P(0,32,0),P(0,32,18),P(0,0,18)]));
      chemin(g,'sil',`fill:${CRAIE}`).setAttribute('d',poly([P(0,0,0),P(52,0,0),P(52,32,0),P(0,32,0)]));
      const fac=[0,1,2].map(()=>{const h=mk('g',{},g);return{p:pave(h,[BEURRE,BEURRE2,BEURRE3]),gr:chemin(h,'nf grain'),h}});
      const av=mk('g',{},g);pave(av).set(P,0,52,30,32,0,18);pave(av).set(P,50,52,0,30,0,18);
      chemin(av,'nf lo').setAttribute('d',seg(P(0,32,6),P(52,32,6))+seg(P(0,32,12),P(52,32,12))+seg(P(52,0,6),P(52,30,6))+seg(P(52,0,12),P(52,30,12)));
      const fl=chemin(av,'nf hi','stroke-width:1.8');fl.setAttribute('d',open([P(23,32,9),P(26,32,14),P(29,32,9)])+seg(P(26,32,9),P(26,32,3))+seg(P(23.5,32,3),P(28.5,32,3)));
      const cv=mk('g',{},g),couv=pave(cv);
      return t=>{
        fac.forEach((f,i)=>{const z=lerp(48,1+i*4.4,seg01(t,300+i*1100,1300+i*1100));f.p.set(P,5,47,5,27,z,z+3.2);f.gr.setAttribute('d',fil(P,5,47,5,27,z+3.25,3));f.h.style.opacity=t>6500?0:1});
        const zc=lerp(44,18,seg01(t,3900,4800));cv.style.opacity=(t<3600||t>6500)?0:1;couv.set(P,-1,53,-1,33,zc,zc+2);
      }
    };

    /* 7. Livraison sur rendez-vous */
    S.livre=svg=>{
      const P=scene(svg,[[-10,-4,0],[104,30,0],[0,0,46],[104,30,46]],3.3),g=mk('g',{},svg);
      chemin(g,'nf lo').setAttribute('d',seg(P(-30,24,0),P(110,24,0))+seg(P(-30,-2,0),P(110,-2,0)));
      const cg=mk('g',{},g),caisse=pave(cg),cab=pave(cg,[BEURRE,BEURRE2,BEURRE3]),vitre=chemin(cg,'sil',`fill:${CRAIE}`);
      const logo=chemin(cg,'nf','fill:#151311;stroke:none;fill-rule:evenodd');logo.setAttribute('d','M481.01,285.2v212.12h212.12v-212.12h-212.12ZM666.62,430.9h0v1.22c0,21.11-67.96,19.75-79.55,19.75s-79.55,1.36-79.55-19.75v-2.43c0-21.11,67.96-19.75,79.55-19.75s79.55-1.36,79.55,19.75v1.22Z');
      const roues=[0,1].map(()=>({r:chemin(cg,'sil','fill:#151311'),m:chemin(cg,'nf','stroke:#F2E9B1;stroke-width:1.4')}));
      const mg=mk('g',{},g);
      pave(mg).set(P,70,96,0,24,0,20);
      chemin(mg,'sil',`fill:${BLANC}`).setAttribute('d',poly([P(70,24,20),P(96,24,20),P(83,24,32)]));
      chemin(mg,'sil',`fill:${BLANC}`).setAttribute('d',poly([P(83,0,32),P(83,24,32),P(96,24,20),P(96,0,20)]));
      chemin(mg,'sil',`fill:${BEURRE}`).setAttribute('d',poly([P(79,24.05,0),P(87,24.05,0),P(87,24.05,12),P(79,24.05,12)]));
      const pin=mk('g',{},g),pc=chemin(pin,'sil',`fill:${BLANC}`),pd=mk('circle',{r:3,class:'sil',style:`fill:${BEURRE}`},pin);
      return t=>{
        const x=lerp(-50,4,seg01(t,0,2400));cg.style.opacity=t>6300?(1-(t-6300)/500).toFixed(2):1;
        caisse.set(P,x,x+30,4,20,3,21);cab.set(P,x+30,x+42,4,20,3,15);
        vitre.setAttribute('d',poly([P(x+42.05,7,9),P(x+42.05,17,9),P(x+42.05,17,14),P(x+42.05,7,14)]));
        /* le symbole Jacamar, tracé exact du logo, posé dans le plan du flanc de la caisse */
        const lx=x+9.5,lz=6.5,ls=11,k=212.12,F=(u,v)=>P(lx+u*ls,20.05,lz+ls-v*ls),O=F(0,0),U=F(1,0),V=F(0,1);
        const ma=(U[0]-O[0])/k,mb=(U[1]-O[1])/k,mc=(V[0]-O[0])/k,md=(V[1]-O[1])/k;
        logo.setAttribute('transform',`matrix(${ma.toFixed(5)} ${mb.toFixed(5)} ${mc.toFixed(5)} ${md.toFixed(5)} ${(O[0]-ma*481.01-mc*285.2).toFixed(2)} ${(O[1]-mb*481.01-md*285.2).toFixed(2)})`);
        const ang=-(x+46)/3.5;
        [x+7,x+34].forEach((wx,i)=>{const q=[];for(let k=0;k<24;k++){const a=k/24*6.2832;q.push(P(wx+3.6*Math.cos(a),20.1,3.6+3.6*Math.sin(a)))}roues[i].r.setAttribute('d',poly(q));
          roues[i].m.setAttribute('d',seg(P(wx+2.6*Math.cos(ang),20.2,3.6+2.6*Math.sin(ang)),P(wx-2.6*Math.cos(ang),20.2,3.6-2.6*Math.sin(ang))))});
        const pv=t>2500&&t<6600,bz=pv?(t<3000?lerp(14,0,seg01(t,2500,3000)):Math.max(0,2*Math.sin((t-3000)/260)*Math.exp(-(t-3000)/700))):0;
        const c=P(83,24,40+bz);pin.style.opacity=pv?1:0;
        pc.setAttribute('d',`M${c[0].toFixed(1)} ${(c[1]+16).toFixed(1)}c-6-8-11-12-11-18a11 11 0 0 1 22 0c0 6-5 10-11 18z`);
        pd.setAttribute('cx',c[0].toFixed(1));pd.setAttribute('cy',(c[1]-2).toFixed(1));
      }
    };

    window.JCM_PARCOURS=S;
    document.querySelectorAll('.jcm-parcours').forEach(sec=>{
      const tr=sec.querySelector('.jp-track'),prec=sec.querySelector('.jp-prec'),suiv=sec.querySelector('.jp-suiv'),barre=sec.querySelector('.jp-barre i');
      if(!tr)return;
      const pas=()=>{const c=tr.querySelector('.jp-carte');return c?c.getBoundingClientRect().width:300};
      const maj=()=>{const m=tr.scrollWidth-tr.clientWidth,p=m>0?tr.scrollLeft/m:1;if(barre)barre.style.width=(Math.max(.08,tr.clientWidth/tr.scrollWidth)*100).toFixed(1)+'%',barre.style.left=(p*(100-parseFloat(barre.style.width))).toFixed(1)+'%';if(prec)prec.disabled=tr.scrollLeft<4;if(suiv)suiv.disabled=tr.scrollLeft>m-4;sec.classList.toggle('jp-fin',tr.scrollLeft>m-4)};
      prec&&prec.addEventListener('click',()=>tr.scrollBy({left:-pas(),behavior:'smooth'}));
      suiv&&suiv.addEventListener('click',()=>tr.scrollBy({left:pas(),behavior:'smooth'}));
      tr.addEventListener('scroll',maj,{passive:!0});addEventListener('resize',maj);maj();
    });
    HL.inject(document);
    document.querySelectorAll('.jcm-parcours [data-scene]').forEach(st=>{
      const f=S[st.dataset.scene];if(!f)return;
      const svg=mk('svg',{viewBox:'0 0 400 400','aria-hidden':'true'},st),draw=f(svg),t0=performance.now(),h=n=>(n-t0)%T;
      draw(T*.55);
      if(matchMedia('(prefers-reduced-motion: reduce)').matches)return;
      register(st,(dt,now)=>{draw(h(now));return!0});
    });
  };
  window.HL&&document.readyState!=='loading'?lancer():document.addEventListener('DOMContentLoaded',lancer);
})();
